import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { type TextInputProps, TextInput, Box } from '@mantine/core'
import { clsx } from 'clsx'
import { useEffect, useState } from 'react'

import { getHttpProtocolFromString } from '@flecto/utils'

import { Icon } from '../Icon/Icon'
import { DropdownUrlProtocol } from './DropdownUrlProtocol'
import styles from './styles.module.css'

export type InputUrlProps = Omit<TextInputProps, 'onChange'> & {
  onChange?: (url: string | null) => void
  clearable?: boolean
}

export function InputUrl({ clearable = true, ...props }: InputUrlProps) {
  const [url, setUrl] = useState('')
  const [httpProtocol, setHttpProtocol] = useState('https://')
  const classes = clsx(styles.input, styles[props.size ?? ''], props.className)

  const onSelectProtocol = (protocol: string) => {
    setHttpProtocol(protocol)
    propagateChanges(protocol, url)
  }

  const propagateChanges = (protocol: string, url: string) => {
    props.onChange?.(`${protocol}${url}`)
  }

  useEffect(() => {
    if (!props.value) {
      return
    }

    const value = String(props.value || '')
    const protocol = getHttpProtocolFromString(value) ?? 'https://'
    const urlSplitted = value.replace(protocol, '').split('://')
    const url = urlSplitted.length > 1 ? urlSplitted[1] : urlSplitted[0]

    setHttpProtocol(protocol)
    setUrl(url)
    propagateChanges(protocol, url)
  }, [props.value])

  return (
    <TextInput
      placeholder='www.example.com'
      {...props}
      value={url}
      className={classes}
      leftSection={
        <DropdownUrlProtocol
          size={props.size}
          currentProtocol={httpProtocol}
          onChange={onSelectProtocol}
          withErrors={Boolean(props.error)}
        />
      }
      onChange={(e) => {
        const url = e.target.value.replace(' ', '')
        setHttpProtocol(httpProtocol)
        setUrl(url)
        propagateChanges(httpProtocol, url)
      }}
      rightSection={
        clearable && url.length > 0 ? (
          <Box
            mr='md'
            mt={2}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setUrl('')
              props.onChange?.(null)
            }}
          >
            <Icon icon={faTimes} color='gray.5' />
          </Box>
        ) : undefined
      }
    />
  )
}
